"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.logoffPunter = logoffPunter;
const AAPITypes_1 = require("../AAPITypes");
function logoffPunter() {
    const correlationData = this.addToCorrelation({});
    if (this.initializationParams.useJSON) {
        const request = {
            aapiId: AAPITypes_1.aapiId.logoffPunter,
            correlationId: correlationData.correlationDataId,
        };
        this._sendStreamingMessageJSON(request);
    }
    else {
        const request = { 0: correlationData.correlationDataId };
        this._sendStreamingMessage(AAPITypes_1.aapiId.logoffPunter, request);
    }
    return correlationData.promise;
}
